'use client'

import { useSession } from 'next-auth/react'
import { useEffect } from 'react'

declare global {
  interface Window {
    FS?: (method: string, data: Record<string, unknown>) => void
  }
}

export function FullStoryIdentify() {
  const { data: session } = useSession()

  useEffect(() => {
    if (!session?.user || !window.FS) return

    const { id, name, email } = session.user

    window.FS('setIdentity', {
      uid: id,
      properties: {
        displayName: name || undefined,
        email: email || undefined,
      },
    })
  }, [session?.user])

  return null
}
